module.exports = __webpack_public_path__ + "static/img/renzheng.1ca52c24.jpg";